import classNames from 'classnames';
import { ComponentPropsWithoutRef } from 'react';
import styles from './LeaderboardThumbnail.module.scss';

export type LeaderboardThumbnailProps = {
  me?: boolean;
} & ComponentPropsWithoutRef<'img'>;
export const LeaderboardThumbnail = ({ className, me, ...props }: LeaderboardThumbnailProps) => (
  <div className={classNames(styles.root, { [styles.me]: me }, className)}>
    <img width="36" height="36" alt="thumbnail" {...props} />
  </div>
);
